<template>

  <v-card class="dashboardcontent">

        <v-card-actions>  
    <v-btn      
      icon
      :to="'/'+$home+'content/usecase'"
      >      
      <v-icon>mdi-table-of-contents</v-icon>
    </v-btn>
    </v-card-actions>    

  <v-list-item two-line>
      <v-list-item-icon
        class="dash-icon"
        >
        <v-icon
          size="24"          
          >mdi-cog-outline</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title class="d-title">
          Anwendungsfälle
        </v-list-item-title>        
      </v-list-item-content>
    </v-list-item>
    
  <v-data-table
      v-model="selected"
      :headers="headers"
      :items="usecases"
      :footer-props="{
        'disable-items-per-page': true        
      }"      
      :items-per-page="30"
      :single-select="singleSelect"
      :search="search"
      item-key="id"
      class="elevation-1 list-blank"
    >

    <template v-slot:body="{ items }">
      <tbody>
        <tr
          v-for="(item) in items"
          :key="item.id"
        >
          <td>{{ item.id }}</td>
          <td>
            <router-link :to="'/'+$home+'node/usecase/' + item.id" text small>
            {{ item.name }}
            </router-link>
          </td>                                             
          <td>
            <v-btn :to="'/'+$home+'node/usecase/' + item.id" class="" text small>
              <v-icon size="18" >mdi-pencil</v-icon>
            </v-btn>   
            <!--               
            <v-btn @click="deleteTf(index,item.id)" class="" text small>
              <v-icon size="18" >mdi-delete</v-icon>
            </v-btn>
            -->
          </td>
        </tr>
      </tbody>
    </template>

  </v-data-table>

  </v-card>
</template>

<script>
export default {
  name: 'DashboardUsecases',  
  props: ['type'],
  data () {
    return {
      singleSelect: false,
      selected: [],
      search: '',
      headers: [
        { text: 'ID',
          align: 'start',
          value: 'id',
          sortable: false
        },
        {
          text: 'Name',
          value: 'name'          
        },
        {
          text: '',
          value: 'index'
        }
      ],
      usecases: [],
      overlaydata: null
    }
  },
  methods: {
      getUsecases() {          
          this.axios.get( this.$config.host+"/usecases" ).then(response => (
            this.usecases = response.data            
          ));
      }
  },
  mounted() {  
    this.getUsecases();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
